import { render } from "./MobileMenu.vue?vue&type=template&id=774f94a9&scoped=true"
import script from "./MobileMenu.vue?vue&type=script&lang=js"
export * from "./MobileMenu.vue?vue&type=script&lang=js"

import "./MobileMenu.vue?vue&type=style&index=0&id=774f94a9&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Trinity_Projects\\cesp_skuuni_admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774f94a9"]])

export default __exports__